
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mvp",
      function () {
        return require("private-next-pages/mvp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mvp"])
      });
    }
  